import { render, staticRenderFns } from "./procedure.vue?vue&type=template&id=4d069a4a&scoped=true&lang=html&"
import script from "./procedure.vue?vue&type=script&lang=js&"
export * from "./procedure.vue?vue&type=script&lang=js&"
import style0 from "./procedure.vue?vue&type=style&index=0&id=4d069a4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d069a4a",
  null
  
)

export default component.exports